import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';

export interface MobileAppCMSI extends CMSApiBase {
  showAndroid: boolean;
  showIos: boolean;
  showPwa: boolean;
  iosLink: string;
  androidApk?: CMSImageBase;
}

export const mobileAppCMS = () =>
  request<MobileAppCMSI>({
    url: buildCmsUrl({
      path: 'mobile-app',
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<MobileAppCMSI>
    ),
  });
